import { render } from "./SiteTitle.vue?vue&type=template&id=516bafe8&scoped=true"
import script from "./SiteTitle.vue?vue&type=script&lang=js"
export * from "./SiteTitle.vue?vue&type=script&lang=js"

import "./SiteTitle.vue?vue&type=style&index=0&id=516bafe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516bafe8"]])

export default __exports__